// "Name mit Anrede" makes the widget store "Anrede, Nachname, Vorname" (skylab utils/fullName.ts)
const SALUTATIONS = ['Frau', 'Herr', 'Prof.', 'Dr.'];

const NOT_A_FIRST_NAME =
  /^(frau|herr|fr\.?|hr\.?|dr\.?|prof\.?|familie|fam\.?|firma)$/i;

// Group names and name particles ("van Berg") are not "Firstname Lastname"
const NOT_A_PERSON =
  /^(gruppe|team|hotel|caf[eé]|restaurant|verein|van|von|de|der|den|ter|zu|di|da|del|la|le)$/i;

// Staff often type "Lastname Firstname" already, only guests reliably write "Firstname Lastname"
const STAFF_SOURCES = ['inhouse', 'phone'];

// Moving a part to the front must not create a spreadsheet formula in the CSV export
const startsFormula = (value: string) => /^[=+\-@]/.test(value);

const commaParts = (name: string) =>
  name
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

// Guests are entered as "Lastname, Firstname" or "Firstname Lastname"
export const lastNameOf = (name: string) => {
  const trimmed = name.trim();

  if (trimmed.includes(',')) {
    const parts = commaParts(trimmed);

    if (parts.length >= 3 && SALUTATIONS.includes(parts[0])) return parts[1];

    return trimmed.split(',')[0].trim();
  }

  return trimmed.split(/\s+/).slice(-1)[0] ?? '';
};

// Only reorders names whose order is certain, everything else stays as typed
export const lastNameFirst = (name: string, source?: string) => {
  const trimmed = name.trim();

  // Walk-ins are named "Walkin 2.1, 2.2"
  if (/\d/.test(trimmed)) return name;

  if (trimmed.includes(',')) {
    const parts = commaParts(trimmed);

    if (
      parts.length >= 3 &&
      SALUTATIONS.includes(parts[0]) &&
      !startsFormula(parts[1])
    )
      return parts.slice(1).join(', ');

    return name;
  }

  if (!source || STAFF_SOURCES.includes(source.toLowerCase())) return name;

  const words = trimmed.split(/\s+/);

  if (
    words.length !== 2 ||
    NOT_A_FIRST_NAME.test(words[0]) ||
    NOT_A_PERSON.test(words[0]) ||
    startsFormula(words[1])
  )
    return name;

  return `${words[1]}, ${words[0]}`;
};
